import intersection from 'images/fovPreview/intersection'
import doorway from 'images/fovPreview/doorway'
import hallway from 'images/fovPreview/hallway'
import indoorRoom from 'images/fovPreview/indoorRoom'
import lobby from 'images/fovPreview/lobby'
import parkingLot from 'images/fovPreview/parkingLot'
import vehicleEntrance from 'images/fovPreview/vehicleEntrance'
import threesixty from 'images/fovPreview/360'
import blank from 'images/fovPreview/white'
import oneeighty from 'images/fovPreview/180'

export const intersectionScene = intersection

export default {
  Intersection: intersection,
  Doorway: doorway,
  Hallway: hallway,
  'Indoor Room': indoorRoom,
  Lobby: lobby,
  'Parking Lot': parkingLot,
  'Vehicle Entrance': vehicleEntrance,
  '360': threesixty,
  '180': oneeighty,
  'Blank': blank
}



// WEBPACK FOOTER //
// ./src/helpers/fovPreview/scenes.js